import { toast } from "react-toastify";

const TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 2800,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export function showCommissionInvoiceSuccessToast(message) {
  toast.success(message, TOAST_OPTIONS);
}

export function showCommissionInvoiceInfoToast(message) {
  toast.info(message, TOAST_OPTIONS);
}

export function showCommissionInvoiceErrorToast(message) {
  toast.error(message, { ...TOAST_OPTIONS, autoClose: 4500 });
}
